// https://github.com/championswimmer/vuex-module-decorators

import axios from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { Challenge } from "@/models/definitions";

interface ChallengeRaw {
  id: number;
  campaign_id: number;
  date: string | null;
  title: string;
  text: string;
}

@Module
export default class Challenges extends VuexModule {
  challenges: Challenge[] = [];

  @Mutation
  setChallenges(challenges: ChallengeRaw[]) {
    this.challenges = [];
    for (const challenge of challenges) {
      this.challenges.push({
        ...challenge,
        date: challenge.date ? new Date(challenge.date) : null,
      });
    }
  }

  @Action({ commit: "setChallenges" })
  async fetchChallenges() {
    const response = await axios.get<ChallengeRaw[]>(
      process.env.VUE_APP_API_ROOT_URL + "api/challenges"
    );
    return response.data;
  }

  get allChallenges(): Challenge[] {
    return this.challenges;
  }

  get allChallengesForCampaign(): (id: number) => Challenge[] {
    return (id: number) =>
      this.challenges.filter((challenge) => challenge.campaign_id == id);
  }

  get numTotalChallengesForCampaign() {
    return (id: number) =>
      this.challenges.filter((challenge) => challenge.campaign_id == id).length;
  }
}
